import { useCallback } from 'react';
import { useNavComponentManager } from './useNavComponentManager';
export const useInvokeCapability = capability => {
  const {
    invokeCapability
  } = useNavComponentManager();
  return useCallback(args => {
    invokeCapability(capability, args);
  }, [capability, invokeCapability]);
};